import { Acma_amateurradiocallsignprefixes, Acma_amateurradiocallsigntypes, Acma_amateurradiolocations } from '../api';

export const isSpecialEventCallSign = (
  prefix?: Acma_amateurradiocallsignprefixes,
  type?: Acma_amateurradiocallsigntypes,
  location?: Acma_amateurradiolocations,
) =>
  //VK0 OR VK9
  (prefix === Acma_amateurradiocallsignprefixes.VK &&
    (location === Acma_amateurradiolocations.Antarctic || location === Acma_amateurradiolocations.AustralianExternalTerritories)) ||
  //2 * 1 Contest call signs
  (prefix === Acma_amateurradiocallsignprefixes.VK && type === Acma_amateurradiocallsigntypes.TwoByOneContest) ||
  prefix === Acma_amateurradiocallsignprefixes.VJ ||
  prefix === Acma_amateurradiocallsignprefixes.VL ||
  //VI call signs
  prefix === Acma_amateurradiocallsignprefixes.SpecialEvent;

export const isContestCallsign = (prefix?: Acma_amateurradiocallsignprefixes, type?: Acma_amateurradiocallsigntypes, location?: Acma_amateurradiolocations) =>
  (prefix === Acma_amateurradiocallsignprefixes.VK && type === Acma_amateurradiocallsigntypes.TwoByOneContest) ||
  prefix === Acma_amateurradiocallsignprefixes.VJ ||
  prefix === Acma_amateurradiocallsignprefixes.VL;

export const isVK0ORVK9 = (prefix?: Acma_amateurradiocallsignprefixes, type?: Acma_amateurradiocallsigntypes, location?: Acma_amateurradiolocations) =>
  //VK0 OR VK9
  prefix === Acma_amateurradiocallsignprefixes.VK &&
  (location === Acma_amateurradiolocations.Antarctic || location === Acma_amateurradiolocations.AustralianExternalTerritories);

export const isSpecialEvent = (prefix?: Acma_amateurradiocallsignprefixes) =>
  prefix === Acma_amateurradiocallsignprefixes.SpecialEvent;

export const isFSeries = (type?: Acma_amateurradiocallsigntypes, letters?: string) =>
  type === Acma_amateurradiocallsigntypes.ThreeLetter && letters?.length == 4 && letters?.startsWith("F");
